import { render, staticRenderFns } from "./PorletInfoBox.vue?vue&type=template&id=30d784d9&"
import script from "./PorletInfoBox.vue?vue&type=script&lang=js&"
export * from "./PorletInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./PorletInfoBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports